import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import httpclient from "../../utils";
import GlobalURL from "../../utils/global";
import {
  AppBar,
  Box,
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Tab,
  Tabs,
  TextField,
  Tooltip,
  Typography,
  styled,
  useMediaQuery,
  useTheme,
  Snackbar,
  Backdrop,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";

import PropTypes from "prop-types";
import OrderCard from "../../Components/Warehouse/OrderCard";
import { Masonry } from "@mui/lab";
import PickupList from "../PickupList";
import {
  AutoAwesomeMosaic,
  DoneAllOutlined,
  Loop,
  Print,
  TableRows,
} from "@mui/icons-material";
import PrintDialog from "../../Components/PrintDialog";
import TableComponentView from "../../Components/TableComponentView";
import ViewOrderList from "../../Components/Warehouse/ViewOrderList";
import SelectView from "../../Components/SelectView";
import ButtonDropDown from "../../Components/ButtonDropDown";
import TableNotification from "../../Components/TableNotification";
import ViewNotification from "../../Components/Warehouse/ViewNotification";
import ViewHistory from "../../Components/Warehouse/ViewHistory";
import ExpressOrderComponent from "../../Components/Warehouse/ExpressOrderComponent";
import InstoreOrderComponent from "../../Components/Warehouse/InstoreOrderComponent";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SearchBox = styled(Box)(({ theme }) => ({
  "& input": {
    padding: "12px",
  },
}));

const NotificationBox = styled(Box)(({ theme }) => ({
  margin: "10px 0",
  "& span": {
    padding: "10px 15px",
    border: "1px solid #f1f1f1",
    marginRight: "20px",
    borderRadius: "6px",
  },
}));

const columns = [
  // { id: "id", name: "ID" },
  { id: "check", name: " " },
  { id: "number", name: "Order Number" },
  { id: "clientName", name: "Client" },
  { id: "added", name: "Added Date" },
  { id: "lastModified", name: "Updated Date" },
  { id: "total", name: "Total" },
  { id: "items", name: "Items" },
  { id: "actions", name: "Actions" },
];

const columnsNotification = [
  { id: "orderNumber", name: "Order Number" },
  { id: "fromEmail", name: "From Email" },
  { id: "toEmail", name: "To Email" },
  { id: "created_at", name: "Created Date" },
  { id: "updated_at", name: "Updated Date" },
  { id: "pendingProcess", name: "Status" },
  { id: "actions", name: "Actions" },
];

const columnsNotificationSMS = [
  { id: "orderNumber", name: "Order Number" },
  { id: "customerName", name: "Customer Name" },
  { id: "fromStore", name: "From Store" },
  { id: "created_at", name: "Created Date" },
  { id: "updated_at", name: "Updated Date" },
  { id: "status", name: "Status" },
  { id: "actions", name: "Actions" },
];

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3, pb: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const FittingsOrders = (props) => {
  const configRowPerPage = JSON.parse(localStorage.getItem("configRowPerPage"));
  const sessionTabValue = JSON.parse(sessionStorage.getItem("tabValue"));
  const navigate = useNavigate();
  const { id } = useParams();
  const [orderList, setOrderList] = useState([]);
  const [orderListAll, setOrderListAll] = useState([]);
  const [orderListNP, setOrderListNP] = useState([]);
  const [pickupList, setPickupList] = useState([]);
  const [pickupOrder, setPickupOrder] = useState([]);
  const [notificationList, setNotificationList] = useState([]);
  const [notificationListSMS, setNotificationListSMS] = useState([]);
  const [fulfilledOrderList, setFulfilledOrderList] = useState([]);
  const [readyPickedList, setReadyPickedList] = useState([]);

  const [showPrintDialog, setShowPrintDialog] = useState(false);
  const [printDetails, setPrintDetails] = useState("");
  const [view, setView] = useState(1);

  const [searchText, setSearchText] = useState("");
  const [searchText2, setSearchText2] = useState("");
  const [searchText3, setSearchText3] = useState("");
  const [searchText4, setSearchText4] = useState("");
  const [searchNotification, setSearchNotification] = useState("");
  const [searchTextPicked, setSearchTextPicked] = useState("");

  const [filteredData, setFilteredData] = useState([]);
  const [filteredDataNP, setFilteredDataNP] = useState([]);
  const [filteredData2, setFilteredData2] = useState([]);
  const [filteredData3, setFilteredData3] = useState([]);
  const [filteredData3NP, setFilteredData3NP] = useState([]);
  const [filteredData4, setFilteredData4] = useState([]);
  const [filteredData4SMS, setFilteredData4SMS] = useState([]);
  const [filteredDataPicked, setFilteredDataPicked] = useState([]);

  const [dateFilter, setDateFilter] = useState("1Day");
  const [expressList, setExpressList] = useState([]);
  const [expressListAll, setExpressListAll] = useState([]);
  const [expressListNP, setExpressListNP] = useState([]);
  const [notificationType, setNotificationType] = useState("email");

  const [orderDetails, setOrderDetails] = useState({});
  const [loading, setLoading] = useState(false);
  var [currSalesDocumentID, setCurrSalesDocumentID] = useState("");
  const [expressSalesDocumentID, setExpressSalesDocumentID] = useState("");
  const [currOrderNumbers, setCurrOrderNumbers] = useState(0);
  const [checkedValues, setCheckedValues] = useState([]);

  const [markCheckValues, setMarkCheckValues] = useState([]);

  const [openNotification, setOpenNotification] = useState(false);
  const [notificationDetails, setNotificationDetails] = useState({});

  const [openHistoryDialog, setOpenHistoryDialog] = useState(false);
  const [historyDetails, setHistoryDetails] = useState("");

  //snackbar msg
  const [open, setOpen] = useState(false);
  const [snackStatus, setSnackStatus] = useState("");
  const [snackMessage, setSnackMessage] = useState("");
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [backdropNumber, setBackdropNumber] = useState(5);

  //order count
  const [warehouseOrderCount, setWarehouseOrderCount] = useState(0);
  const [fulfilledOrderCount, setFulfilledOrderCount] = useState(0);
  const [expressOrderCount, setExpressOrderCount] = useState(0);
  const [transferOrderCount, setTransferOrderCount] = useState(0);
  const [notificationCount, setNotificationCount] = useState(0);
  const [readyToPickCount, setReadyToPickCount] = useState(0);
  const [preparingOrderCount, setPrepairingOrderCount] = useState(0);

  //tabValue
  const [value, setValue] = useState(sessionTabValue ? sessionTabValue : 0);
  const [transferValue, setTransferValue] = useState(0);
  const [expressPrintedValue, setExpressPrintedValue] = useState(0);

  const [orderName, setOrderName] = useState("");
  const [openViewDetails, setOpenViewDetails] = useState(false);
  const [viewDetails, setViewDetails] = useState("");

  //pagination
  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [to, setTo] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPage, setRowsPerPage] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [total, setTotal] = useState("");
  const [lastPage, setLastPage] = useState("");
  //pagination
  //pagination
  const [pageNP, setPageNP] = useState(1);
  const [fromNP, setFromNP] = useState(1);
  const [toNP, setToNP] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageNP, setRowsPerPageNP] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalNP, setTotalNP] = useState("");
  const [lastPageNP, setLastPageNP] = useState("");
  //pagination

  //notification pagination
  const [pageNots, setPageNots] = useState(1);
  const [fromNots, setFromNots] = useState(1);
  const [toNots, setToNots] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageNots, setRowsPerPageNots] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalNots, setTotalNots] = useState("");
  const [lastPageNots, setLastPageNots] = useState("");
  //notification pagination

  //notification pagination
  const [pageNotsSMS, setPageNotsSMS] = useState(1);
  const [fromNotsSMS, setFromNotsSMS] = useState(1);
  const [toNotsSMS, setToNotsSMS] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageNotsSMS, setRowsPerPageNotsSMS] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalNotsSMS, setTotalNotsSMS] = useState("");
  const [lastPageNotsSMS, setLastPageNotsSMS] = useState("");
  //notification pagination

  //express pagination
  const [pageExpress, setPageExpress] = useState(1);
  const [fromExpress, setFromExpress] = useState(1);
  const [toExpress, setToExpress] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageExpress, setRowsPerPageExpress] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalExpress, setTotalExpress] = useState("");
  const [lastPageExpress, setLastPageExpress] = useState("");
  //express pagination
  //express pagination
  const [pageExpressNP, setPageExpressNP] = useState(1);
  const [fromExpressNP, setFromExpressNP] = useState(1);
  const [toExpressNP, setToExpressNP] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageExpressNP, setRowsPerPageExpressNP] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalExpressNP, setTotalExpressNP] = useState("");
  const [lastPageExpressNP, setLastPageExpressNP] = useState("");
  //express pagination

  //fulfilled pagination
  const [pageFul, setPageFul] = useState(1);
  const [fromFul, setFromFul] = useState(1);
  const [toFul, setToFul] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPageFul, setRowsPerPageFul] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalFul, setTotalFul] = useState("");
  const [lastPageFul, setLastPageFul] = useState("");
  //fulfilled pagination

  //ready for Collection pagination
  const [pagePicked, setPagePicked] = useState(1);
  const [fromPicked, setFromPicked] = useState(1);
  const [toPicked, setToPicked] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [rowsPerPagePicked, setRowsPerPagePicked] = useState(
    configRowPerPage && configRowPerPage
      ? configRowPerPage && configRowPerPage
      : 20
  );
  const [totalPicked, setTotalPicked] = useState("");
  const [lastPagePicked, setLastPagePicked] = useState("");
  //ready for Collection pagination

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (event, newValue) => {
    setValue(newValue);
    // sessionStorage.setItem("tabValue", JSON.stringify(newValue));

    navigate(`/fittings/orders/${id}/tab_${newValue}`);
    // window.location.hash = `#tab${newValue}`;
  };

  const handleChangeExpressTab = (event, newValue) => {
    setExpressPrintedValue(newValue);
    setSearchText3("");
    navigate(`/fittings/orders/${id}/tab_${newValue}`);
  };

  const handleChangeInstoretab = (event, newValue) => {
    // setExpressPrintedValue(newValue);
    setSearchText("");
    navigate(`/fittings/orders/${id}/tab_${newValue}`);
  };

  useEffect(() => {
    getOrderListAll();
    getExpressOrdersAll();
  }, [id])

  useEffect(() => {
    getOrderCount();
    // getOrderList();
    // getExpressOrders();
    setMarkCheckValues([]);

    if (props.index === "express") {
      getExpressOrders();
      setOrderDetails({});
      setPickupOrder([]);
      setCheckedValues([]);

    }

    if (props.index === "instore") {
      getOrderList();
      setOrderDetails({});
      setPickupOrder([]);
      setOrderName("");
      setCheckedValues([]);

    }

    if (props.index === "pickup") {
      setCheckedValues([]);

    }

    // if (props.index === "fulfilled") {
    //   getFulfilledOrders();
    //   setPickupOrder([]);
    //   setOrderDetails({});
    //   setOrderName("");
    //   setCheckedValues([]);
    // }

    if (props.index === "ready_to_be_picked") {
      getReadyToBePicked();
      setPickupOrder([]);
      setOrderDetails({});
      setOrderName("");
      setCheckedValues([]);

    }

    if (props.index === "notification") {
      // console.log("notification type", notificationType);

      getNotificationLists();
      setPickupOrder([]);
      setOrderDetails({});
      setOrderName("");
      setCheckedValues([]);

    }
  }, [
    id,
    props.index,
    transferValue,
    notificationType,
    props.expressIndex,
    props.instoreIndex,
  ]);

  useEffect(() => {
    if (currSalesDocumentID || expressSalesDocumentID) {
      const getOrderDocInterval = setInterval(getOrderUsingDocumentID, 10000);

      return () => {
        clearInterval(getOrderDocInterval);
      };
    }
  });

  useEffect(() => {
    const getCountInterval = setInterval(getOrderCount, 20000);
    return () => {
      clearInterval(getCountInterval);
    };
  });

  useEffect(() => {
    var number = localStorage.getItem("view");
    if (number) {
      var cookieViewNum = JSON.parse(number);
      setView(cookieViewNum);
    }
    setValue(sessionTabValue ? sessionTabValue : 0);
  }, []);

  const getOrderUsingDocumentID = () => {
    if (props.index === "express" || props.index === "instore") {
      httpclient
        .get(
          `wms/orders?salesDocumentID=${props.index === "express"
            ? expressSalesDocumentID
            : currSalesDocumentID
          }&warehouseID=${id}&type=${props.index === "express" || props.index === "instore"
            ? props.index
            : ""
          }`
        )
        .then(({ data }) => {
          if (data.success) {
            setCurrOrderNumbers(data.records.total);
          }
        });
    }
  };

  const getOrderCount = () => {
    httpclient.get(`wms/order/count?warehouseID=${id}`).then(({ data }) => {
      if (data.success) {
        setWarehouseOrderCount(data.records.warehouseOrder);
        setFulfilledOrderCount(data.records.fulfilledOrder);
        setExpressOrderCount(data.records.expressOrder);
        setTransferOrderCount(data.records.inventoryTransferCount);
        setNotificationCount(data.records.sms + data.records.email);
        setCurrSalesDocumentID(data.records.latestSalesDocumentID);
        setExpressSalesDocumentID(data.records.latestExpressSalesDocumentID);
        setReadyToPickCount(data.records.readyToBePickedOrder);
        setPrepairingOrderCount(data.records.preparingOrder);
      }
    });
  };

  //Warehouse or Instore Order tab

  const getExpressOrdersAll = (value) => {
  
    httpclient
      .get(
        `wms/express/order?warehouseID=${id}&isPrinted=1&deleted=0&recordsOnPage=1000`
      )
      .then(({ data }) => {
        if (data.success) {
          setExpressListAll(data.records.data);
 
        } else {
     
        }
      })
      .catch((e) => {
        if (e.status === 401) {
        
        }
     
      });
  };

  const getOrderListAll = () => {

    httpclient
      .get(
        `wms/orders?warehouseID=${id}&isPrinted=1&deleted=0&recordsOnPage=1000`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderListAll(data.records.data);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
         
        }
   
      });
  };

  // console.log("orderlist all", orderListAll);
  // console.log("expresslist all", expressListAll);

  const getOrderList = () => {

    setLoading(true);
    httpclient
      .get(
        `wms/orders?warehouseID=${id}&${props.instoreIndex === "instore_printed_orders"
          ? "isPrinted=1&deleted=0"
          : props.instoreIndex == undefined
            ? "isPrinted=1"
            : "isPrinted=0"
        }&sort_by=added&direction=asc`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderList(data.records.data);
          if (props.instoreIndex === "instore_printed_orders") {
            setFilteredData(data.records.data);
            setLoading(false);
            setTotal(data.records.total);
            setRowsPerPage(parseInt(data.records.per_page));
            setPage(data.records.current_page);
            setFrom(data.records.from);
            setLastPage(data.records.last_page);
            setTo(data.records.to);
          }
          else if (props.instoreIndex === "instore_order_to_be_printed") {

            setFilteredDataNP(data.records.data);
            setLoading(false);
            setTotalNP(data.records.total);
            setRowsPerPageNP(parseInt(data.records.per_page));
            setPageNP(data.records.current_page);
            setFromNP(data.records.from);
            setLastPageNP(data.records.last_page);
            setToNP(data.records.to);
          }

          getOrderCount();

          setCurrOrderNumbers(0);

          setBackdropNumber(5);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleOrderChangePage = (e, page) => {
    setLoading(true);
    httpclient
      .get(
        `wms/orders?warehouseID=${id}&page=${page}&recordsOnPage=${rowsPerPage}&isExpress=0&keywords=${searchText}&${props.instoreIndex === "instore_printed_orders"
          ? "isPrinted=1&deleted=0"
          : props.instoreIndex == undefined
            ? "isPrinted=1"
            : "isPrinted=0"
        }&sort_by=added&direction=asc`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderList(data.records.data);
          if (props.instoreIndex === "instore_printed_orders") {

            setFilteredData(data.records.data);
            setLoading(false);
            setTotal(data.records.total);
            setRowsPerPage(parseInt(data.records.per_page));
            setPage(data.records.current_page);
            setFrom(data.records.from);
            setLastPage(data.records.last_page);
            setTo(data.records.to);
          }
          else if (props.instoreIndex === "instore_order_to_be_printed") {

            setFilteredDataNP(data.records.data);
            setLoading(false);
            setTotalNP(data.records.total);
            setRowsPerPageNP(parseInt(data.records.per_page));
            setPageNP(data.records.current_page);
            setFromNP(data.records.from);
            setLastPageNP(data.records.last_page);
            setToNP(data.records.to);
          }
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleOrderChangeRows = (e) => {
    setRowsPerPage(e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoading(true);
    httpclient
      .get(
        `wms/orders?warehouseID=${id}&page=${1}&recordsOnPage=${e.target.value
        }&${props.instoreIndex === "instore_printed_orders"
          ? "isPrinted=1&deleted=0"
          : props.instoreIndex == undefined
            ? "isPrinted=1"
            : "isPrinted=0"
        }&sort_by=added&direction=asc`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderList(data.records.data);
          if (props.instoreIndex === "instore_printed_orders") {

            setFilteredData(data.records.data);
            setLoading(false);
            setTotal(data.records.total);
            setRowsPerPage(parseInt(data.records.per_page));
            setPage(data.records.current_page);
            setFrom(data.records.from);
            setLastPage(data.records.last_page);
            setTo(data.records.to);
          }
          else if (props.instoreIndex === "instore_order_to_be_printed") {

            setFilteredDataNP(data.records.data);
            setLoading(false);
            setTotalNP(data.records.total);
            setRowsPerPageNP(parseInt(data.records.per_page));
            setPageNP(data.records.current_page);
            setFromNP(data.records.from);
            setLastPageNP(data.records.last_page);
            setToNP(data.records.to);
          }
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const handleChangeSearch = (e) => {
    if (e.target.value === "") {
      getOrderList();
    }
    setSearchText(e.target.value);
  };

  const handleSearch = (e) => {
    httpclient
      .get(
        `wms/search/orders?warehouseID=${id}&isExpress=0&keywords=${searchText}&${props.instoreIndex === "instore_printed_orders"
          ? "isPrinted=1&deleted=0"
          : props.instoreIndex == undefined
            ? "isPrinted=1"
            : "isPrinted=0"
        }`
      )
      .then(({ data }) => {
        if (data.success) {
          setOrderList(data.records.data);
          if (props.instoreIndex === "instore_printed_orders") {

            setFilteredData(data.records.data);
            setLoading(false);
            setTotal(data.records.total);
            setRowsPerPage(parseInt(data.records.per_page));
            setPage(data.records.current_page);
            setFrom(data.records.from);
            setLastPage(data.records.last_page);
            setTo(data.records.to);
          }
          else if (props.instoreIndex === "instore_order_to_be_printed") {

            setFilteredDataNP(data.records.data);
            setLoading(false);
            setTotalNP(data.records.total);
            setRowsPerPageNP(parseInt(data.records.per_page));
            setPageNP(data.records.current_page);
            setFromNP(data.records.from);
            setLastPageNP(data.records.last_page);
            setToNP(data.records.to);
          }
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };
  //Warehouse or Instore Order tab


  //express order tab 6

  


  const getExpressOrders = (value) => {
    setLoading(true);
    httpclient
      .get(
        `wms/express/order?warehouseID=${id}&${props.expressIndex === "express_printed_orders"
          ? "isPrinted=1&deleted=0"
          : props.expressIndex == undefined
            ? "isPrinted=1"
            : "isPrinted=0"
        }&sort_by=added&direction=asc`
      )
      .then(({ data }) => {
        if (data.success) {
          setExpressList(data.records.data);
          if (props.expressIndex === "express_printed_orders") {

            setLoading(false);
            setFilteredData3(data.records.data);
            setTotalExpress(data.records.total);
            setRowsPerPageExpress(parseInt(data.records.per_page));
            setPageExpress(data.records.current_page);
            setFromExpress(data.records.from);
            setLastPageExpress(data.records.last_page);
            setToExpress(data.records.to);

          } else if (props.expressIndex === "express_order_to_be_printed") {

            setLoading(false);
            setFilteredData3NP(data.records.data);
            setTotalExpressNP(data.records.total);
            setRowsPerPageExpressNP(parseInt(data.records.per_page));
            setPageExpressNP(data.records.current_page);
            setFromExpressNP(data.records.from);
            setLastPageExpressNP(data.records.last_page);
            setToExpressNP(data.records.to);
          }

          setCurrOrderNumbers(0);
          setBackdropNumber(5);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleExpressPage = (e, page) => {
    setLoading(true);
    httpclient
      .get(
        `wms/express/order?warehouseID=${id}&page=${page}&recordsOnPage=${rowsPerPageExpress}&isExpress=1&${props.expressIndex === "express_printed_orders"
          ? "isPrinted=1&deleted=0"
          : "isPrinted=0"
        }&keywords=${searchText3}&sort_by=added&direction=asc`
      )
      .then(({ data }) => {
        if (data.success) {
          setExpressList(data.records.data);
          if (props.expressIndex === "express_printed_orders") {

            setLoading(false);
            setFilteredData3(data.records.data);
            setTotalExpress(data.records.total);
            setRowsPerPageExpress(parseInt(data.records.per_page));
            setPageExpress(data.records.current_page);
            setFromExpress(data.records.from);
            setLastPageExpress(data.records.last_page);
            setToExpress(data.records.to);

          } else if (props.expressIndex === "express_order_to_be_printed") {

            setLoading(false);
            setFilteredData3NP(data.records.data);
            setTotalExpressNP(data.records.total);
            setRowsPerPageExpressNP(parseInt(data.records.per_page));
            setPageExpressNP(data.records.current_page);
            setFromExpressNP(data.records.from);
            setLastPageExpressNP(data.records.last_page);
            setToExpressNP(data.records.to);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleExpressRows = (e) => {
    setRowsPerPageExpress(e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoading(true);
    httpclient
      .get(
        `wms/express/order?warehouseID=${id}&page=${1}&recordsOnPage=${e.target.value
        }&${props.expressIndex === "express_printed_orders"
          ? "isPrinted=1&deleted=0"
          : "isPrinted=0"
        }&sort_by=added&direction=asc`
      )
      .then(({ data }) => {
        if (data.success) {
          setExpressList(data.records.data);
          if (props.expressIndex === "express_printed_orders") {

            setLoading(false);
            setFilteredData3(data.records.data);
            setTotalExpress(data.records.total);
            setRowsPerPageExpress(parseInt(data.records.per_page));
            setPageExpress(data.records.current_page);
            setFromExpress(data.records.from);
            setLastPageExpress(data.records.last_page);
            setToExpress(data.records.to);

          } else if (props.expressIndex === "express_order_to_be_printed") {

            setLoading(false);
            setFilteredData3NP(data.records.data);
            setTotalExpressNP(data.records.total);
            setRowsPerPageExpressNP(parseInt(data.records.per_page));
            setPageExpressNP(data.records.current_page);
            setFromExpressNP(data.records.from);
            setLastPageExpressNP(data.records.last_page);
            setToExpressNP(data.records.to);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  //express search
  const handleKeyDownExpress = (e) => {
    if (e.key === "Enter") {
      handleSearchExpress();
    }
  };

  const handleChangeSearchExpress = (e) => {
    if (e.target.value === "") {
      getExpressOrders();
    }
    setSearchText3(e.target.value);
  };

  const handleSearchExpress = (e) => {
    httpclient
      .get(
        `wms/search/orders?warehouseID=${id}&isExpress=1&keywords=${searchText3}&${props.expressIndex === "express_printed_orders"
          ? "isPrinted=1&deleted=0"
          : "isPrinted=0"
        }`
      )
      .then(({ data }) => {
        if (data.success) {
          setExpressList(data.records.data);
          if (props.expressIndex === "express_printed_orders") {

            setLoading(false);
            setFilteredData3(data.records.data);
            setTotalExpress(data.records.total);
            setRowsPerPageExpress(parseInt(data.records.per_page));
            setPageExpress(data.records.current_page);
            setFromExpress(data.records.from);
            setLastPageExpress(data.records.last_page);
            setToExpress(data.records.to);

          } else if (props.expressIndex === "express_order_to_be_printed") {

            setLoading(false);
            setFilteredData3NP(data.records.data);
            setTotalExpressNP(data.records.total);
            setRowsPerPageExpressNP(parseInt(data.records.per_page));
            setPageExpressNP(data.records.current_page);
            setFromExpressNP(data.records.from);
            setLastPageExpressNP(data.records.last_page);
            setToExpressNP(data.records.to);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  //express search

  //express order tab

  //notification tab
  const getNotificationLists = () => {
    setLoading(true);
    httpclient
      .get(`wms/${notificationType}?env=TEST&warehouseID=${id}`)
      .then(({ data }) => {
        if (data.success) {
          if (notificationType === "email") {
            setNotificationList(data.records.data);
            setLoading(false);
            setFilteredData4(data.records.data);
            setTotalNots(data.records.total);
            setRowsPerPageNots(parseInt(data.records.per_page));
            setPageNots(data.records.current_page);
            setFromNots(data.records.from);
            setLastPageNots(data.records.last_page);
            setToNots(data.records.to);
          }
          else if (notificationType === "sms") {
            setNotificationListSMS(data.records.data);
            setLoading(false);
            setFilteredData4SMS(data.records.data);
            setTotalNotsSMS(data.records.total);
            setRowsPerPageNotsSMS(parseInt(data.records.per_page));
            setPageNotsSMS(data.records.current_page);
            setFromNotsSMS(data.records.from);
            setLastPageNotsSMS(data.records.last_page);
            setToNotsSMS(data.records.to);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleChangeNotificationPage = (e, page) => {
    setLoading(true);
    httpclient
      .get(
        `wms/${notificationType}?env=TEST&warehouseID=${id}&page=${page}&recordsOnPage=${rowsPerPage}`
      )
      .then(({ data }) => {
        if (data.success) {
          if (notificationType === "email") {
            setNotificationList(data.records.data);
            setLoading(false);
            setFilteredData4(data.records.data);
            setTotalNots(data.records.total);
            setRowsPerPageNots(parseInt(data.records.per_page));
            setPageNots(data.records.current_page);
            setFromNots(data.records.from);
            setLastPageNots(data.records.last_page);
            setToNots(data.records.to);
          }
          else if (notificationType === "sms") {
            setNotificationListSMS(data.records.data);
            setLoading(false);
            setFilteredData4SMS(data.records.data);
            setTotalNotsSMS(data.records.total);
            setRowsPerPageNotsSMS(parseInt(data.records.per_page));
            setPageNotsSMS(data.records.current_page);
            setFromNotsSMS(data.records.from);
            setLastPageNotsSMS(data.records.last_page);
            setToNotsSMS(data.records.to);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleNotificationRows = (e) => {
    setRowsPerPage(e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoading(true);
    httpclient
      .get(
        `wms/${notificationType}?env=TEST&warehouseID=${id}&page=${1}&recordsOnPage=${e.target.value
        }`
      )
      .then(({ data }) => {
        if (data.success) {
          if (notificationType === "email") {
            setNotificationList(data.records.data);
            setLoading(false);
            setFilteredData4(data.records.data);
            setTotalNots(data.records.total);
            setRowsPerPageNots(parseInt(data.records.per_page));
            setPageNots(data.records.current_page);
            setFromNots(data.records.from);
            setLastPageNots(data.records.last_page);
            setToNots(data.records.to);
          }
          else if (notificationType === "sms") {
            setNotificationListSMS(data.records.data);
            setLoading(false);
            setFilteredData4SMS(data.records.data);
            setTotalNotsSMS(data.records.total);
            setRowsPerPageNotsSMS(parseInt(data.records.per_page));
            setPageNotsSMS(data.records.current_page);
            setFromNotsSMS(data.records.from);
            setLastPageNotsSMS(data.records.last_page);
            setToNotsSMS(data.records.to);
          }
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleKeyDownNotification = (e) => {
    if (e.key === "Enter") {
      handleSearchNotification();
    }
  };

  const handleSearchNotification = (e) => {
    setSearchNotification(e.target.value);
    var searchValue = e.target.value;

    var filtered = notificationList.filter((order) => {
      var orderNum = order.number;
      var toEmail = order.toEmail;
      var fromEmail = order.fromEmail;
      return (
        toEmail.toLowerCase().match(new RegExp(searchValue, "g")) ||
        fromEmail.toString().match(new RegExp(searchValue, "g")) ||
        orderNum.toString().match(new RegExp(searchValue, "g"))
      );
    });

    setFilteredData4(filtered);
  };

  const handleViewMessage = (row) => {
    setOpenNotification(true);
    setNotificationDetails(row);
  };

  const sendNotificationDetail = (call) => {
    if (call.open === false) {
      setOpenNotification(false);
      setNotificationDetails({});
    }
  };

  const handleResendMessage = (row) => {
    if (window.confirm(`Are you sure you resend the ${notificationType}`)) {
      httpclient(
        `${GlobalURL[0].url
        }/${notificationType === "email" ? "sendEmail" : "sendSMS"
        }?env=TEST&type=resend&id=${row.id}`
      ).then(({ data }) => {
        if (data.success) {
          setOpen(true);
          setSnackStatus("success");
          setSnackMessage(data.message);
          setTimeout(() => {
            getNotificationLists();
          }, 1000);
        } else {
          setOpen(true);
          setSnackStatus("error");
          setSnackMessage(data.message);
        }
      });
    }
  };

  const handleViewHistory = (row) => {
    setOpenHistoryDialog(true);
    setHistoryDetails(row);
  };

  const sendHistoryCallback = (call) => {
    if (call.open === false) {
      setOpenHistoryDialog(false);
      setHistoryDetails("");
    }
  };
  //notification tab

  //ready for Collection tab
  const getReadyToBePicked = () => {
    setLoading(true);
    httpclient
      .get(`wms/readyToBePicked/order?env=TEST&warehouseID=${id}`)
      .then(({ data }) => {
        if (data.success) {
          setReadyPickedList(data.records.data);
          setLoading(false);
          setFilteredDataPicked(data.records.data);

          setTotalPicked(data.records.total);
          setRowsPerPagePicked(parseInt(data.records.per_page));
          setPagePicked(data.records.current_page);
          setFromPicked(data.records.from);
          setLastPagePicked(data.records.last_page);

          setToPicked(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleChangePickedPage = (e, page) => {
    setLoading(true);
    httpclient
      .get(
        `wms/readyToBePicked/order?env=TEST&warehouseID=${id}&page=${page}&recordsOnPage=${rowsPerPage}`
      )
      .then(({ data }) => {
        if (data.success) {
          setReadyPickedList(data.records.data);
          setLoading(false);
          setFilteredDataPicked(data.records.data);

          setTotalPicked(data.records.total);
          setRowsPerPagePicked(parseInt(data.records.per_page));
          setPagePicked(data.records.current_page);
          setFromPicked(data.records.from);
          setLastPagePicked(data.records.last_page);

          setToPicked(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleChangePickedRows = (e) => {
    setRowsPerPage(e.target.value);
    localStorage.setItem("configRowPerPage", e.target.value);

    setLoading(true);
    httpclient
      .get(
        `wms/readyToBePicked/order?env=TEST&warehouseID=${id}&page=${page}&recordsOnPage=${e.target.value}&isExpress=2&keywords=${searchTextPicked}&pickedOrder=0&readyToFulfill=1`
      )
      .then(({ data }) => {
        if (data.success) {
          setReadyPickedList(data.records.data);
          setLoading(false);
          setFilteredDataPicked(data.records.data);

          setTotalPicked(data.records.total);
          setRowsPerPagePicked(parseInt(data.records.per_page));
          setPagePicked(data.records.current_page);
          setFromPicked(data.records.from);
          setLastPagePicked(data.records.last_page);

          setToPicked(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleKeyDownPicked = (e) => {
    if (e.key === "Enter") {
      handleSearchPicked();
    }
  };

  const handleChangeSearchPicked = (e) => {
    if (e.target.value === "") {
      getReadyToBePicked();
    }
    setSearchTextPicked(e.target.value);
  };

  const handleSearchPicked = (e) => {
    httpclient
      .get(
        `wms/search/orders?warehouseID=${id}&isExpress=2&keywords=${searchTextPicked}&pickedOrder=0&readyToFulfill=1`
      )
      .then(({ data }) => {
        if (data.success) {
          setReadyPickedList(data.records.data);
          setLoading(false);
          setFilteredDataPicked(data.records.data);

          setTotalPicked(data.records.total);
          setRowsPerPagePicked(parseInt(data.records.per_page));
          setPagePicked(data.records.current_page);
          setFromPicked(data.records.from);
          setLastPagePicked(data.records.last_page);

          setToPicked(data.records.to);
        } else {
          setLoading(false);
        }
      })
      .catch((e) => {
        if (e.status === 401) {
          setLoading(false);
        }
        setLoading(false);
      });
  };

  const handleMarkPick = (order) => {
    if (
      window.confirm(
        "Are you sure you want the to mark the order as collected?"
      )
    ) {
      httpclient
        .post(`wms/updateToPicked/order?env=TEST&warehouseID=${id}`, {
          ids: order.id,
        })
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getReadyToBePicked();
              getOrderCount();
              setCheckedValues([]);

              setMarkCheckValues([]);
              setSearchTextPicked("");
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    } else {
      setSearchTextPicked("");
      getReadyToBePicked();
    }
  };

  const handleMultipleMark = () => {
    let salesIDs = markCheckValues.join(",");

    if (
      window.confirm(
        "Are you sure you want the to mark the selected orders as picked?"
      )
    ) {
      httpclient
        .post(`wms/updateToPicked/order?env=TEST&warehouseID=${id}`, {
          ids: salesIDs,
        })
        .then(({ data }) => {
          if (data.success) {
            setOpen(true);
            setSnackStatus("success");
            setSnackMessage(data.message);
            setTimeout(() => {
              getReadyToBePicked();
              getOrderCount();
              setCheckedValues([]);

              setMarkCheckValues([]);
            }, 500);
          } else {
            setOpen(true);
            setSnackStatus("error");
            setSnackMessage(data.message);
          }
        });
    }
  };

  //ready for Collection tab

  const handleRefetch = () => {
    if (props.index === "express") {
      getExpressOrders();
    }

    if (props.index === "instore") {
      getOrderList();
    }

    setTimeout(() => {
      setCurrOrderNumbers(0);
    }, 2000);
  };

  // const getPickupList = () => {
  //   setLoading(true);
  //   httpclient
  //     .get(`wms/orders/lines?warehouseID=${id}`)
  //     .then(({ data }) => {
  //       if (data.success) {
  //         setPickupList(data.records);
  //         setLoading(false);
  //       }
  //     })
  //     .catch((e) => {
  //       if (e.status === 401) {
  //         setLoading(false);
  //       }
  //       setLoading(false);
  //     });
  // };

  const handlePickupOrder = (order) => {
    setPickupOrder(order);
    setOrderDetails(order);
    // setValue(2);
    navigate(`/fittings/orders/${id}/tab_pickup`);
  };

  const handlePrint = (option, order) => {
    //console.log("ordersssss is", order);
    setCheckedValues([order.id]);

    setPrintDetails(
      `${GlobalURL[0].url}/getReceipt?warehouseID=${id}&salesDocumentIDs=${order.id
      }&size=${option === "Print" ? true : false}`
    );
    setShowPrintDialog(true);
  };

  useEffect(() => {
    let intervalId;
    if (openBackdrop) {
      intervalId = setInterval(() => {
        setBackdropNumber((prevBackdropNumber) => {
          if (prevBackdropNumber > 1) {
            return prevBackdropNumber - 1;
          } else {
            clearInterval(intervalId);
            setOpenBackdrop(false);

            props.index === "express" ? getExpressOrders() : getOrderList();
            setCheckedValues([]);

            setTimeout(() => {
              return 5;
            }, 1000);
          }
        });
      }, 1000);
      return () => {
        // Clear the interval when the component unmounts
        clearInterval(intervalId);
      };
    }
  }, [openBackdrop === true]);

  const callbackPrintPreview = (call) => {
    if (call.open === false) {
      setShowPrintDialog(false);
      setPrintDetails("");
      // setCheckedValues([]);

      if (props.index === "express" || props.index === "instore") {
        setOpenBackdrop(true);
      } else {
        setCheckedValues([]);

      }
    }
  };

  // console.log("backdrop number", backdropNumber);
  // console.log('backdrop >>>', openBackdrop);

  const handleOrderCodeFilter = (value) => {
    setOrderName(value);
    // orderList.map((order) => {
    //   if (order.number === value) {
    //     setPickupOrder(order);
    //     setOrderDetails(order);
    //   }
    // });

    httpclient
      .get(`wms/search/orders?warehouseID=${id}&isExpress=2&keywords=${value}`)
      .then(({ data }) => {
        if (data.success) {
          setPickupOrder(data.records.data[0]);
          setOrderDetails(data.records.data[0]);
        }
      });
  };

  const handleOrderFilter = (value) => {
    setOrderName(value !== null ? value.number : "");

    orderListAll.map((order) => {
      if (order.id === value.id) {
        setPickupOrder(order);
        setOrderDetails(order);
      }
    });
    expressListAll.map((order) => {
      if (order.id === value.id) {
        setPickupOrder(order);
        setOrderDetails(order);
      }
    });
  };

  const handleChangeOrder = (e) => {
    setOrderName(e.target.value);
  };

  const handleView = (num) => {
    setView(num);
    localStorage.setItem("view", JSON.stringify(num));
  };

  const handleViewDetails = (order) => {
    setOpenViewDetails(true);
    setViewDetails(order);
  };

  const sendViewDetails = (call) => {
    if (call.open === false) {
      setOpenViewDetails(false);
      setViewDetails("");
    }
  };

  //checked to print
  const handleCheck = (e, row) => {
    const newCheckedValues = [...checkedValues];
    const newMarkValues = [...markCheckValues];

    if (newCheckedValues.includes(row.id)) {
      if (e.target.checked === false) {
        var res = newCheckedValues.filter((che) => che !== row.id);
        var markRes = markCheckValues.filter((mark) => mark !== row.id);
        setCheckedValues(res);

        setMarkCheckValues(markRes);
      }
    } else {
      newCheckedValues.push(row.id);
      newMarkValues.push(row.id);
      setCheckedValues(newCheckedValues);

      setMarkCheckValues(newMarkValues);
    }
  };

  const handleMultiplePrint = (option, order) => {

    let salesIDs = checkedValues.join(",");
    setPrintDetails(
      `${GlobalURL[0].url}/getReceipt?warehouseID=${id}&salesDocumentIDs=${salesIDs}&size=${option === "Print" ? true : false
      }`
    );
    setShowPrintDialog(true);
  };
  //checked to print

  //snackbar mui
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            orientation={isMobile ? "vertical" : "horizontal"}
            value={props.index}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab
              label={
                <span>
                  <span>{`Express Orders`}</span>
                  <span
                    className={expressOrderCount == "0" ? "" : "dark_text"}
                  >{` ( ${expressOrderCount} ) `}</span>
                </span>
              }
              value="express"
            />

            <Tab
              label={
                <span>
                  <span>{`Instore Fittings`}</span>
                  <span
                    className={warehouseOrderCount == "0" ? "" : "dark_text"}
                  >{` ( ${warehouseOrderCount} ) `}</span>
                </span>
              }
              value="instore"
            />
            <Tab
              label={
                <span>
                  <span>{`Preparing Orders`}</span>
                  <span
                    className={preparingOrderCount === "0" ? "" : "dark_text"}
                  >
                    {` ( ${preparingOrderCount} ) `}{" "}
                  </span>
                </span>
              }
              value="pickup"
            />

            {/* <Tab
              label={`Released Orders(${fulfilledOrderCount})`}
              value="fulfilled"
            /> */}

            <Tab
              label={
                <span>
                  <span>{`Ready for Collection`}</span>
                  <span
                    className={readyToPickCount == "0" ? "" : "dark_text"}
                  >{` ( ${readyToPickCount} ) `}</span>
                </span>
              }
              value="ready_to_be_picked"
            />

            {/* <Tab
              label={`Notifications(${notificationCount})`}
              value="notification"
            /> */}
          </Tabs>
        </Box>

        {/* Express Orders */}
        <CustomTabPanel value={props.index} index={"express"}>
          {props.expressIndex === "express_printed_orders" ? (
            <ExpressOrderComponent
              lastPageExpress={lastPageExpress}
              pageExpress={pageExpress}
              handleExpressPage={handleExpressPage}
              handlePickupOrder={handlePickupOrder}
              handlePrint={handlePrint}
              handleMultiplePrint={handleMultiplePrint}
              currOrderNumbers={currOrderNumbers}
              handleRefetch={handleRefetch}
              handleView={handleView}
              handleKeyDownExpress={handleKeyDownExpress}
              handleChangeSearchExpress={handleChangeSearchExpress}
              searchText3={searchText3}
              isMobile={isMobile}
              loading={loading}
              view={view}
              handleChangeExpressTab={handleChangeExpressTab}
              expressPrintedValue={expressPrintedValue}
              expressIndex={props.expressIndex}
              columns={columns}
              filteredData3={filteredData3}
              totalExpress={totalExpress}
              fromExpress={fromExpress}
              toExpress={toExpress}
              rowsPerPageExpress={rowsPerPageExpress}
              handleExpressRows={handleExpressRows}
              handleViewDetails={handleViewDetails}
              handleCheck={handleCheck}
              checkedValues={checkedValues}

              openBackdrop={openBackdrop}
              backdropNumber={backdropNumber}
            />
          ) : (
            <ExpressOrderComponent
              lastPageExpress={lastPageExpressNP}
              pageExpress={pageExpressNP}
              handleExpressPage={handleExpressPage}
              handlePickupOrder={handlePickupOrder}
              handlePrint={handlePrint}
              handleMultiplePrint={handleMultiplePrint}
              currOrderNumbers={currOrderNumbers}
              handleRefetch={handleRefetch}
              handleView={handleView}
              handleKeyDownExpress={handleKeyDownExpress}
              handleChangeSearchExpress={handleChangeSearchExpress}
              searchText3={searchText3}
              isMobile={isMobile}
              loading={loading}
              view={view}
              handleChangeExpressTab={handleChangeExpressTab}
              expressPrintedValue={expressPrintedValue}
              expressIndex={props.expressIndex}
              columns={columns}
              filteredData3={filteredData3NP}
              totalExpress={totalExpressNP}
              fromExpress={fromExpressNP}
              toExpress={toExpressNP}
              rowsPerPageExpress={rowsPerPageExpressNP}
              handleExpressRows={handleExpressRows}
              handleViewDetails={handleViewDetails}
              handleCheck={handleCheck}
              checkedValues={checkedValues}

              openBackdrop={openBackdrop}
              backdropNumber={backdropNumber}
            />

          )}
        </CustomTabPanel>
        {/* Express Orders */}

        {/* Warehouse Orders */}
        <CustomTabPanel value={props.index} index={"instore"}>
          {props.instoreIndex === "instore_printed_orders" ? (
            <InstoreOrderComponent
              isMobile={isMobile}
              lastPage={lastPage}
              page={page}
              handleOrderChangePage={handleOrderChangePage}
              filteredData={filteredData}
              handlePrint={handlePrint}
              handlePickupOrder={handlePickupOrder}
              checkedValues={checkedValues}

              handleCheck={handleCheck}
              handleViewDetails={handleViewDetails}
              columns={columns}
              total={total}
              from={from}
              to={to}
              handleOrderChangeRows={handleOrderChangeRows}
              rowsPerPage={rowsPerPage}
              handleMultiplePrint={handleMultiplePrint}
              handleView={handleView}
              view={view}
              handleRefetch={handleRefetch}
              currOrderNumbers={currOrderNumbers}
              handleKeyDown={handleKeyDown}
              handleChangeSearch={handleChangeSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              handleChangeInstoretab={handleChangeInstoretab}
              instoreIndex={props.instoreIndex}
              openBackdrop={openBackdrop}
              backdropNumber={backdropNumber}
              loading={loading}
            />
          ) : (
            <InstoreOrderComponent
              isMobile={isMobile}
              lastPage={lastPageNP}
              page={pageNP}
              handleOrderChangePage={handleOrderChangePage}
              filteredData={filteredDataNP}
              handlePrint={handlePrint}
              handlePickupOrder={handlePickupOrder}
              checkedValues={checkedValues}

              handleCheck={handleCheck}
              handleViewDetails={handleViewDetails}
              columns={columns}
              total={totalNP}
              from={fromNP}
              to={toNP}
              handleOrderChangeRows={handleOrderChangeRows}
              rowsPerPage={rowsPerPageNP}
              handleMultiplePrint={handleMultiplePrint}
              handleView={handleView}
              view={view}
              handleRefetch={handleRefetch}
              currOrderNumbers={currOrderNumbers}
              handleKeyDown={handleKeyDown}
              handleChangeSearch={handleChangeSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              handleChangeInstoretab={handleChangeInstoretab}
              instoreIndex={props.instoreIndex}
              openBackdrop={openBackdrop}
              backdropNumber={backdropNumber}
              loading={loading}
            />

          )}
        </CustomTabPanel>
        {/* Warehouse Orders */}

        {/* Preparing orders */}
        <CustomTabPanel value={props.index} index={"pickup"}>
          <PickupList
            pickupList={pickupOrder?.sales_details || []}
            order={orderDetails}
            setOrder={setOrderDetails}
            //loading={loading}
            pickupOrder={true}
            setPickupOrder={setPickupOrder}
            setValue={setValue}
            orderList={orderListAll}
            expressList={expressListAll}
            orderName={orderName}
            setOrderName={setOrderName}
            handleOrderFilter={handleOrderFilter}
            handleChangeOrder={handleChangeOrder}
            handleOrderCodeFilter={handleOrderCodeFilter}
            setPickupList={setPickupList}



          />
        </CustomTabPanel>
        {/* Preparing orders */}


        {/* Notifications Tab */}
        <CustomTabPanel value={props.index} index={"notification"}>
          <Box
            pb={3}
            display={"flex"}
            flexDirection={isMobile ? "column" : "row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <Box flex={"1"}>
              <InputLabel>Search</InputLabel>
              <SearchBox display={"flex"}>
                <TextField
                  type="search"
                  variant="outlined"
                  name="searchNotification"
                  value={searchNotification}
                  onChange={handleSearchNotification}
                  onKeyDown={handleKeyDownNotification}
                  sx={{ width: "300px" }}
                />
              </SearchBox>
            </Box>
            <Box textAlign={"center"} flex="1" sx={{ marginTop: "10px" }}>
              <h2>Notification</h2>
            </Box>
            <Box textAlign={"right"} flex="1"></Box>
          </Box>

          <NotificationBox pb={2}>
            <span
              style={{
                cursor: "pointer",
                fontWeight: notificationType === "email" ? "700" : "400",
                background: notificationType === "email" ? "#1976d2" : "#fff",
                color: notificationType === "email" ? "#fff" : "inherit",
              }}
              onClick={() => setNotificationType("email")}
            >
              Email
            </span>

            <span
              style={{
                cursor: "pointer",
                fontWeight: notificationType === "sms" ? "700" : "400",
                background: notificationType === "sms" ? "#1976d2" : "#fff",
                color: notificationType === "sms" ? "#fff" : "inherit",
              }}
              onClick={() => setNotificationType("sms")}
            >
              SMS
            </span>
          </NotificationBox>
          <Box>
            {!loading ? (
              notificationType === "email" ? (
                <TableNotification
                  columns={columnsNotification}
                  rows={filteredData4}
                  total={totalNots}
                  from={fromNots}
                  to={toNots}
                  rowsPerPage={rowsPerPageNots}
                  page={pageNots}
                  handleChangePage={handleChangeNotificationPage}
                  handleChangeRowsPerPage={handleNotificationRows}
                  handleViewMessage={handleViewMessage}
                  handleResendMessage={handleResendMessage}
                  handleViewHistory={handleViewHistory}
                // handleViewDetails={handleViewDetails}
                // handlePrint={handlePrint}
                // fulfilled={true}
                // handleCheck={handleCheck}
                // checkedValues={checkedValues}
                />
              ) : (
                <TableNotification
                  columns={columnsNotificationSMS}
                  rows={filteredData4SMS}
                  total={totalNotsSMS}
                  from={fromNotsSMS}
                  to={toNotsSMS}
                  rowsPerPage={rowsPerPageNotsSMS}
                  page={pageNotsSMS}
                  handleChangePage={handleChangeNotificationPage}
                  handleChangeRowsPerPage={handleNotificationRows}
                  handleViewMessage={handleViewMessage}
                  handleResendMessage={handleResendMessage}
                  handleViewHistory={handleViewHistory}
                // handleViewDetails={handleViewDetails}
                // handlePrint={handlePrint}
                // fulfilled={true}
                // handleCheck={handleCheck}
                // checkedValues={checkedValues}
                />
              )
            ) : (
              <Box textAlign={"center"}>
                <CircularProgress />
              </Box>
            )}
          </Box>

        </CustomTabPanel>
        {/* Notifications Tab */}

        {/* Ready for Collection */}
        <CustomTabPanel value={props.index} index={"ready_to_be_picked"}>
          <Box
            pb={3}
            display={"flex"}
            alignItems={"center"}
            flexDirection={isMobile ? "column" : "row"}
            justifyContent={"space-between"}
          >
            <Box flex={"1"}>
              <InputLabel>Search</InputLabel>
              <SearchBox display={"flex"}>
                <TextField
                  type="search"
                  variant="outlined"
                  name="searchTextPicked"
                  value={searchTextPicked}
                  onChange={handleChangeSearchPicked}
                  // onChange={(e) => setSearchTextPicked(e.target.value)}
                  onKeyDown={handleKeyDownPicked}
                  helperText={
                    searchTextPicked
                      ? "Press enter to search Picked up Collections"
                      : ""
                  }
                  sx={{ width: "300px" }}
                />
              </SearchBox>
            </Box>
            <Box textAlign={"center"} flex="1" marginTop={"10px"}>
              <h2>Ready for Collection</h2>
            </Box>
            <Box flex={"1"}></Box>
          </Box>

          {/* Change View */}
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <SelectView handleView={handleView} />
            <span>
              <Box
                display="inline-block"
                width="15px"
                height="15px"
                marginRight="5px"
                backgroundColor="#9FE2BF"
              ></Box>
              Paid Orders

              |


              <Box
                display="inline-block"
                width="15px"
                height="15px"
                marginLeft="10px"
                marginRight="5px"
                backgroundColor="#f5f5f5"
              ></Box>
              Unpaid Orders
            </span>
            {checkedValues.length > 0 ? (
              <>
                <Box
                  textAlign={"right"}
                  display={"flex"}
                  gap="10px"
                  mb={2}
                  mr={2}
                >
                  {/* <ButtonDropDown
                    checkedValues={checkedValues.length}
                    handleClickPrint={handleMultiplePrint}
                  /> */}

                  <Button
                    color="secondary"
                    variant="contained"
                    onClick={handleMultipleMark}
                  >
                    <DoneAllOutlined
                      fontSize="small"
                      style={{ marginRight: "5px" }}
                    />
                    {`Mark as Collected  (${markCheckValues.length})`}
                  </Button>
                </Box>
              </>
            ) : (
              ""
            )}
          </Box>

          {!loading ? (
            view !== 1 ? (
              <>
                <TableComponentView
                  columns={columns}
                  rows={filteredDataPicked}
                  total={totalPicked}
                  from={fromPicked}
                  to={toPicked}
                  rowsPerPage={rowsPerPagePicked}
                  page={pagePicked}
                  handleChangePage={handleChangePickedPage}
                  handleChangeRowsPerPage={handleChangePickedRows}
                  handleViewDetails={handleViewDetails}
                  // handlePrint={handlePrint}
                  handleMarkPick={handleMarkPick}
                  fulfilled={true}
                  handleCheck={handleCheck}
                  checkedValues={checkedValues}

                />
              </>
            ) : (
              <>
                <Masonry
                  columns={{ xs: 1, sm: 2, md: 3 }}
                  spacing={3}
                  sx={{ margin: "0", width: "auto" }}
                >
                  {filteredDataPicked &&
                    filteredDataPicked.map((order) => (
                      <Box key={order.id}>
                        <OrderCard
                          order={order}
                          markPick={true}
                          handleMarkPick={handleMarkPick}
                          handlePrint={handlePrint}
                        />
                      </Box>
                    ))}
                </Masonry>
                {filteredDataPicked.length ? (
                  <Box
                    alignItems={"center"}
                    justifyContent={"center"}
                    display={"flex"}
                  >
                    <Pagination
                      size="large"
                      count={lastPagePicked}
                      page={pagePicked}
                      onChange={handleChangePickedPage}
                      variant="outlined"
                      shape="rounded"
                      color="primary"
                    />
                  </Box>
                ) : (
                  ""
                )}
              </>
            )
          ) : (
            <Box textAlign={"center"}>
              <CircularProgress />
            </Box>
          )}
        </CustomTabPanel>
        {/* Ready for Collection */}
      </Box>

      {showPrintDialog && (
        <PrintDialog
          printDetails={printDetails}
          callbackPrintPreview={callbackPrintPreview}
        />
      )}

      {openNotification && (
        <ViewNotification
          sendNotificationDetail={sendNotificationDetail}
          notificationDetails={notificationDetails}
        />
      )}

      {openHistoryDialog && (
        <ViewHistory
          sendHistoryCallback={sendHistoryCallback}
          historyDetails={historyDetails}
          notificationType={notificationType}
        />
      )}

      {openViewDetails && (
        <ViewOrderList
          viewDetails={viewDetails}
          sendViewDetails={sendViewDetails}
        />
      )}

      <Snackbar
        open={open}
        autoHideDuration={1000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleClose}
          severity={snackStatus}
          sx={{ width: "100%", position: "relative", top: "40px" }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default FittingsOrders;
